import React from 'react'

import {TABLET, DESKTOP} from '../const'
import CustomPropTypes from '../customPropTypes'

import Resp from './Responsive/Resp'
import Source from './Source'

const Tablet = ({children}) => (
  <Resp>
    <Source minWidth={TABLET.START}>{children}</Source>
    <Source minWidth={DESKTOP.START} />
  </Resp>
)

Tablet.propTypes = {
  children: CustomPropTypes.children.isRequired,
}

export default Tablet
